import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import DetailsCard from '@rental-manager/components/DetailsCard';
import { logError } from '@zg-rentals/log-error';

type DepositAccountProps = {
  accountInfo: Record<string, any>;
  goToEditAccountInfoPage: (...args: Array<any>) => any;
  goToPhoneVerificationPage: () => any;
  checkIsPhoneVerificationNeeded: () => any;
};

type State = {
  isPhoneVerificationNeeded: boolean;
};

class DepositAccount extends React.Component<DepositAccountProps> {
  state: State = {
    isPhoneVerificationNeeded: false,
  };

  componentDidMount() {
    this.props
      .checkIsPhoneVerificationNeeded()
      .then((isPhoneVerificationNeeded) => {
        this.setState({ isPhoneVerificationNeeded });
      })
      .catch((err) => {
        this.setState({ isPhoneVerificationNeeded: true });
        logError({ error: err });
      });
  }

  render(): React.ReactNode {
    const { accountInfo, goToEditAccountInfoPage, goToPhoneVerificationPage } = this.props;
    const { accountName, accountLast4 } = accountInfo;

    return (
      <DetailsCard
        title="Deposit Account"
        onEdit={this.state.isPhoneVerificationNeeded ? goToPhoneVerificationPage : goToEditAccountInfoPage}
        className="fs-exclude"
      >
        <Text>
          {accountName} ending in {accountLast4}
        </Text>
      </DetailsCard>
    );
  }
}

export default DepositAccount;
